import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from 'app/_globals';
import { TrainingCourseState } from 'app/_models/training/training-course-state';
import { ContractorService } from 'app/_services/contractor.service';
import { TabItemHelperService } from 'app/_services/tab-item-helper.service';
import { ResendInductionReminderModalComponent } from 'app/shared-pages/site-pages/site-workers/resend-induction-reminder-modal/resend-induction-reminder-modal.component';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-sites',
  templateUrl: './worker-site-list.component.html',
})
export class WorkerSiteList implements OnInit {
  public routeRole: any;
  public tabitems: any[] = [];
  public backLink: any;

  private selectedWorkerId: any;
  public selectedWorker: any;
  public sites: any;

  public TrainingCourseStateType = TrainingCourseState; // allow enum in template
  private siteOwnerId: number;
  public isAdmin: boolean;

  constructor(
    private contractorService: ContractorService,
    private activatedRoute: ActivatedRoute,
    private tabItemHelperService: TabItemHelperService,
    private globals: Globals,
    private modalService: NgbModal,
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.selectedWorkerId = parseInt(params.workerId);
      this.siteOwnerId = parseInt(params.siteOwnerId);
    });

    this.routeRole = globals.user.routeRole;

    this.isAdmin = (this.routeRole === 'admin' || this.routeRole === 'support');

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.siteOwnerId = this.siteOwnerId ? this.siteOwnerId : parseInt(params.siteOwnerId);
      this.backLink = params.backLink;
      this.tabitems = this.tabItemHelperService.getWorkerSectionTabItems(this.routeRole, this.backLink, this.selectedWorkerId, this.siteOwnerId);
    });
  }

  ngOnInit() {
    this.getSelectedWorker(this.selectedWorkerId);
    this.getSitesForWorker(this.selectedWorkerId);
  }

  public getSelectedWorker(id) {
    this.contractorService.getWorkerById(id).subscribe((data: any) => {
      this.selectedWorker = data;
    });
  }

  public getSitesForWorker(id) {
    this.contractorService.getSitesByWorkerId(id).subscribe((data: any) => {
      this.sites = data.map(site => ({
        ...site,
        isSendingInductionReminder: false,
        inductionReminderSent: false,
      }));

      if (!this.isAdmin) {
        this.sites = this.sites.filter(workerSites => workerSites.site.siteOwner.id !== environment.VENTUS_OWNER_SKYLARK_ID);
      }
      this.sites.sort((a, b) => a.site.siteOwner.firstName.localeCompare(b.site.siteOwner.firstName));
    });
  }

  public resendInductionReminder(workerSite: any) {
    const inductionCourse = workerSite && workerSite.site && workerSite.site.siteInductionCourse;
    if (this.routeRole !== 'contractor-manager' || !inductionCourse || workerSite.isSendingInductionReminder || workerSite.inductionReminderSent) {
      return;
    }

    const modalRef = this.modalService.open(ResendInductionReminderModalComponent, { centered: true, size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.workerFirstName = this.selectedWorker ? this.selectedWorker.firstName : '';
    modalRef.componentInstance.siteName = workerSite.site.name;
    modalRef.componentInstance.defaultMessage = `Please complete your induction for ${workerSite.site.name} BEFORE arriving to site`;
    modalRef.componentInstance.skylarkUserId = this.selectedWorkerId;
    modalRef.componentInstance.courseId = inductionCourse.id;
    modalRef.componentInstance.workerEmail = this.selectedWorker && this.selectedWorker.email
      ? this.selectedWorker.email
      : 'worker';

    modalRef.componentInstance.sendingStateChange.subscribe((isSending: boolean) => {
      workerSite.isSendingInductionReminder = isSending;
    });

    modalRef.componentInstance.reminderSent.subscribe(() => {
      workerSite.inductionReminderSent = true;
    });
  }
}
